export function startsWithEmoji(value: string): boolean {
  return /^\p{Extended_Pictographic}/u.test(value.trim())
}

function firstCharKind(value: string): 'emoji' | 'upper' | 'lower' | 'other' {
  const text = value.trim()
  if (!text) return 'other'
  if (/^\p{Extended_Pictographic}/u.test(text)) return 'emoji'
  if (/^\p{Lu}/u.test(text)) return 'upper'
  if (/^\p{Ll}/u.test(text)) return 'lower'
  return 'other'
}

export function formatTagNameForLevel(name: string, level: 2 | 3): string {
  const text = name.trim()
  if (!text) return text
  if (startsWithEmoji(text)) return text
  const chars = [...text]
  if (level === 2 && /^\p{Ll}/u.test(chars[0])) {
    chars[0] = chars[0].toLocaleUpperCase()
  }
  if (level === 3 && /^\p{Lu}/u.test(chars[0])) {
    chars[0] = chars[0].toLocaleLowerCase()
  }
  return chars.join('')
}

export function isLevel2TagName(name: string): boolean {
  const kind = firstCharKind(name)
  return kind === 'emoji' || kind === 'upper'
}

export function tagNameBadgeVariant(name: string): 'default' | 'outline' {
  return isLevel2TagName(name) ? 'default' : 'outline'
}

/** 去掉 emoji 后须为英文词：字母、数字、空格、连字符、撇号、& */
const ENGLISH_BODY = /^[A-Za-z][A-Za-z0-9 \-'&]*$/

export function tagNameEnglishError(name: string): string | null {
  const text = name.trim()
  if (!text) return '标签名不能为空'
  const withoutEmoji = text.replace(/\p{Extended_Pictographic}/gu, '').trim()
  if (!withoutEmoji) return null
  if (ENGLISH_BODY.test(withoutEmoji)) return null
  return '标签名须为英文（字母、数字、空格、连字符）'
}

export function tagNameLevelError(
  name: string,
  level: 2 | 3,
): string | null {
  const kind = firstCharKind(name)
  if (level === 2) {
    if (kind !== 'emoji' && kind !== 'upper') {
      return '2 级标签须以大写字母或表情符号开头'
    }
  } else {
    if (kind === 'emoji') return '表情符号开头视为 2 级，不能建成 3 级'
    if (kind !== 'lower') return '3 级标签须以小写字母开头'
  }
  return tagNameEnglishError(name)
}

export const TAG_LEVEL_NAME_HINT =
  '2 级：大写字母或表情符号开头。3 级：小写字母开头。名称须为英文。数字、符号、其他语言开头不算。'
